function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1,3.26H17.53L28.41,40.91l11-37.65h14.4L36.21,56.88H18.73Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M56.08,7a7,7,0,0,1,7.35-7c4.2,0,7.43,3,7.43,7s-3.23,6.9-7.43,6.9S56.08,11,56.08,7Zm.68,10.65H70.18V56.88H56.76Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M74.46,44.43H86.83c.45,2.85,1.73,4.42,5.55,4.42,3.3,0,4.8-1.27,4.8-3.22s-1.87-2.77-7.27-3.52C79.41,40.76,75,37.68,75,29.51c0-8.7,7.73-12.9,16.8-12.9,9.68,0,16.43,3.3,17.33,12.67H97c-.53-2.62-1.95-3.9-5-3.9-2.92,0-4.42,1.28-4.42,3.08s1.8,2.62,6.6,3.22c10.87,1.35,16.12,4.2,16.12,12.6,0,9.3-6.9,13.5-17.77,13.5C81.28,57.78,74.76,53.13,74.46,44.43Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M113.91,43.23V17.66h13.42v23.4c0,4.42,1.73,6.6,5.55,6.6,4.05,0,6.68-2.4,6.68-7.43V17.66H153V56.88H139.56V50.8c-2.1,4.05-5.93,7-12.45,7C119.53,57.78,113.91,53.13,113.91,43.23Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M157.26,46c0-9.23,7.8-12.83,20.85-12.83h3.75v-.9c0-3.75-.9-6.22-5.18-6.22-3.67,0-5,2.17-5.32,4.65h-12.6c.6-9.45,8-14.1,18.75-14.1s17.7,4.42,17.7,14.85V56.88H182.16V52.3c-1.88,2.85-5.33,5.48-11.63,5.48C163.48,57.78,157.26,54.33,157.26,46Zm24.6-2.85v-2.4h-3.53c-5.4,0-7.8,1.05-7.8,4.27,0,2.25,1.5,3.68,4.65,3.68C179,48.71,181.86,46.53,181.86,43.16Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M201.06.41h13.35V56.88H201.06Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M219.81,7a7,7,0,0,1,7.35-7c4.2,0,7.42,3,7.42,7s-3.22,6.9-7.42,6.9S219.81,11,219.81,7Zm.67,10.65h13.43V56.88H220.48Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M237.58,55.53l17.17-27.75H239.38V17.66H274v1.42L256.33,46.76h16.72V56.88H237.58Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M274.56,37.76v-.6c0-12.6,9.37-20.55,21.22-20.55,10.72,0,20,6.15,20,20.25v3.52h-27.6c.37,5.17,3.37,8.17,8.17,8.17,4.43,0,6.3-2,6.83-4.64h12.6c-1.2,8.85-8,13.87-19.88,13.87C283.56,57.78,274.56,50.58,274.56,37.76Zm28.12-4.95c-.23-4.73-2.55-7.35-6.9-7.35-4,0-6.83,2.62-7.5,7.35Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M334.26,3.26h17.32l17.18,30.22V3.26h13.42V56.88H367.33L347.76,23.21V56.88h-13.5Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M403.56,33.93,386.08,3.26h16.73l9.07,18.07L421,3.26h14.7L419,33.93v23H403.56Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M433,30.41v-.6c0-16.5,11.7-27.38,27.38-27.38,13.95,0,23.62,6.45,24.9,20.63H469.48c-.6-5.48-3.6-8.48-9-8.48-6.9,0-11.25,5.4-11.25,15.15v.6c0,9.68,4.13,15.15,11.48,15.15,5.4,0,9.22-2.85,10-8.77H486c-1.05,13.87-11.1,21.07-25,21.07C442.26,57.78,433,46.83,433,30.41Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M500.38,54.71l18.75-19.88c5.33-5.7,8.85-10.27,8.85-14.77,0-3.6-1.87-6-5.7-6s-6.22,2.32-6.9,8.7H501.43C502,9.33,510.06,2.51,523,2.51s20.1,7.05,20.1,17c0,7.35-4.12,12.9-10.12,18.67l-7.5,7.28h18V56.88H500.38Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M548.61,31.23V29c0-17,10.57-26.47,24.74-26.47s24.75,8.77,24.75,26.17v2.1c0,17-9.75,27-25.05,27C558.06,57.78,548.61,48.11,548.61,31.23Zm34.12-.15V28.91c0-9.83-2.85-14.78-9.38-14.78S564,19,564,28.91v2.25c0,10,2.92,14.7,9.52,14.7S582.73,41,582.73,31.08Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M600.28,54.71,619,34.83c5.32-5.7,8.85-10.27,8.85-14.77,0-3.6-1.88-6-5.7-6s-6.23,2.32-6.9,8.7H601.33c.52-13.43,8.62-20.25,21.6-20.25s20.1,7.05,20.1,17c0,7.35-4.13,12.9-10.13,18.67l-7.5,7.28h18V56.88H600.28Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M658.4,18.41l-10.2,6.3V11.88l12.3-8.62h13.28V56.88H658.4Z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 674 58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.04b89d28.svg";
export { ForwardRef as ReactComponent };